'use client';

import { RefreshCw, TriangleAlert } from 'lucide-react';
import Link from 'next/link';

import { Button } from '@/components/ui/button';
import { useReportError } from '@/hooks/use-report-error';
import { deriveErrorDigest } from '@/lib/utils/derive-error-digest';

export const ErrorScreen = ({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) => {
  useReportError({ error });

  const digest = deriveErrorDigest(error);

  return (
    <div className="flex min-h-full flex-1 flex-col items-center justify-center gap-3 p-6 text-center">
      <TriangleAlert className="size-10 text-muted-foreground" />
      <h1 className="text-2xl font-semibold tracking-tight">
        Une erreur est survenue
      </h1>
      <p className="max-w-md text-muted-foreground">
        Veuillez réessayer, ou contacter le support si le problème persiste.
      </p>
      <div className="mt-3 flex items-center gap-2">
        <Button onClick={() => retry()}>
          <RefreshCw />
          Réessayer
        </Button>
        <Button asChild variant="outline">
          <Link href="/">Retourner à l'accueil</Link>
        </Button>
      </div>
      {digest && (
        <span className="mt-1 font-mono text-xs text-muted-foreground">
          Réf. {digest}
        </span>
      )}
    </div>
  );
};
